export default __webpack_public_path__ + "37fbe24a875e6f5285e959b4ef484790.webp";